import { ro, enUS, es, fr, de, it, pt, ru, zhCN, ja } from 'date-fns/locale';

export const languages = [
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
];

export const dateLocales = {
  ro: ro, en: enUS, es: es, fr: fr, de: de, it: it, pt: pt, ru: ru, zh: zhCN, ja: ja
};

export const translations = {
  ro: {
    // General
    welcome: "Salut",
    welcome_female: "Bună",
    dear_male: "Dragule",
    dear_female: "Draga mea",
    morning: "bună dimineața",
    evening: "bună seara",
    profile: "Profil",
    history: "Istoric",
    radio: "Radio",
    fullscreen: "Full Screen",
    loading: "Se încarcă...",
    
    // Radio & Overlay
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Muzică pentru antrenament",
    playing: "Se redă...",
    paused: "Pauză",
    click_to_play: "Apasă pentru a asculta",
    live: "LIVE",
    want_music: "Vrei să asculți muzică?",
    yes: "Da",
    no: "Nu",
    did_you_know: "Știai cum te ajută mersul astăzi?",

    // Intensity
    intensity_title: "Intensitate",
    locked: "Blocat",
    start: "Start",
    start_desc: "10 min - Acomodare",
    easy: "Ușor",
    easy_desc: "Ritm lejer",
    medium: "Mediu",
    medium_desc: "Efort moderat",
    intense: "Intens",
    intense_desc: "Provocare",
    
    // Quotes/Messages
    msg_start: "Să îi dăm START-ul la pași!",
    msg_easy: "Astăzi să o luăm ușor, ca să nu fim prea stresați.",
    msg_medium: "Hai să nu fie prea ușor astăzi, ceva mediu merge mai bine!",
    msg_intense: "Azi e ziua provocărilor, ceva intens și plin de energie!",
    msg_default: "Pregătit pentru mișcare?",
    
    // User Info
    active_profile: "Profil Activ",
    age_sex: "Vârstă & Sex",
    years: "ani",
    body: "Corp",
    bmi_calc: "IMC Calculat",
    optimized_for: "Optimizat pentru",
    underweight: "Subponderal",
    normal: "Normal",
    overweight: "Supraponderal",
    obese: "Obez",
    sedentary: "Sedentar",
    beginner: "Începător",
    intermediate: "Intermediar",
    advanced: "Avansat",
    
    // Timer & Workout
    warmup: "Încălzire",
    workout: "Antrenament",
    cooldown: "Răcire",
    time_remaining: "Timp Rămas",
    total_time: "Timp Total",
    speed: "Viteză",
    distance: "Distanță",
    steps: "Pași",
    covered: "parcurși",
    progress: "Progres",
    pause: "Pauză",
    resume: "Reia",
    continue: "Continuă",
    stop_confirm: "Vrei să oprești și să salvezi progresul curent?",
    congrats: "Felicitări! Ai completat antrenamentul!",
    
    // Program Details
    structure: "Structură",
    est_km: "km Estimați",
    target_steps: "Pași Target",
    min: "min",
    sec: "sec",
    
    // History
    history_title: "Istoric Activitate",
    history_subtitle: "Evidența progresului tău",
    sessions: "Sesiuni",
    no_history: "Nu ai nicio sesiune salvată încă.",
    start_workout: "Începe un antrenament!",
    delete_history: "Șterge tot istoricul",
    delete_confirm: "Sigur vrei să ștergi tot istoricul?",
    
    // Profile Modal
    lets_start: "Să începem",
    setup_profile: "Configurează profilul pentru a primi un plan personalizat.",
    language: "Limbă / Language",
    firstname: "Prenume",
    firstname_placeholder: "ex. Andrei",
    gender: "Sex",
    male: "Bărbat",
    female: "Femeie",
    age: "Vârstă",
    height: "Înălțime (cm)",
    weight: "Greutate (kg)",
    activity_level: "Nivel Activitate",
    level_sedentary: "Sedentar (Puțină mișcare)",
    level_beginner: "Începător (Ocazional)",
    level_intermediate: "Intermediar (Activ regulat)",
    level_advanced: "Avansat (Sportiv)",
    generate_program: "Generează Program",
    err_name: "Cum te numești?",
    err_sex: "Selectează sexul",
    err_age: "18-100 ani",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",

    // Quotes
    quote1: "Sănătatea este cea mai mare bogăție.",
    quote2: "Fiecare pas contează.",
    quote3: "Nu te opri când ești obosit, oprește-te când ai terminat.",
    quote4: "Disciplina este puntea dintre obiective și realizări.",
    quote5: "Corpul tău poate, mintea ta trebuie convinsă."
  },
  en: {
    welcome: "Hello",
    welcome_female: "Hello",
    dear_male: "Dear",
    dear_female: "Dear",
    morning: "good morning",
    evening: "good evening",
    profile: "Profile",
    history: "History",
    radio: "Radio",
    fullscreen: "Full Screen",
    loading: "Loading...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Workout Music",
    playing: "Playing...",
    paused: "Paused",
    click_to_play: "Click to play",
    live: "LIVE",
    want_music: "Do you want to listen to music?",
    yes: "Yes",
    no: "No",
    did_you_know: "Did you know how walking helps you today?",
    intensity_title: "Intensity",
    locked: "Locked",
    start: "Start",
    start_desc: "10 min - Warmup",
    easy: "Easy",
    easy_desc: "Light pace",
    medium: "Medium",
    medium_desc: "Moderate effort",
    intense: "Intense",
    intense_desc: "Challenge",
    msg_start: "Let's START stepping!",
    msg_easy: "Let's take it easy today, no stress.",
    msg_medium: "Not too easy today, medium works best!",
    msg_intense: "Challenge day, let's get intense and energetic!",
    msg_default: "Ready to move?",
    active_profile: "Active Profile",
    age_sex: "Age & Sex",
    years: "years",
    body: "Body",
    bmi_calc: "BMI Calculated",
    optimized_for: "Optimized for",
    underweight: "Underweight",
    normal: "Normal",
    overweight: "Overweight",
    obese: "Obese",
    sedentary: "Sedentary",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    warmup: "Warmup",
    workout: "Workout",
    cooldown: "Cooldown",
    time_remaining: "Time Remaining",
    total_time: "Total Time",
    speed: "Speed",
    distance: "Distance",
    steps: "Steps",
    covered: "covered",
    progress: "Progress",
    pause: "Pause",
    resume: "Resume",
    continue: "Continue",
    stop_confirm: "Do you want to stop and save current progress?",
    congrats: "Congratulations! Workout completed!",
    structure: "Structure",
    est_km: "Est. km",
    target_steps: "Target Steps",
    min: "min",
    sec: "sec",
    history_title: "Activity History",
    history_subtitle: "Track your progress",
    sessions: "Sessions",
    no_history: "No saved sessions yet.",
    start_workout: "Start a workout!",
    delete_history: "Clear all history",
    delete_confirm: "Are you sure you want to clear history?",
    lets_start: "Let's Start",
    setup_profile: "Setup your profile for a personalized plan.",
    language: "Language",
    firstname: "First Name",
    firstname_placeholder: "e.g. Andrew",
    gender: "Gender",
    male: "Male",
    female: "Female",
    age: "Age",
    height: "Height (cm)",
    weight: "Weight (kg)",
    activity_level: "Activity Level",
    level_sedentary: "Sedentary (Little movement)",
    level_beginner: "Beginner (Occasional)",
    level_intermediate: "Intermediate (Regular active)",
    level_advanced: "Advanced (Athlete)",
    generate_program: "Generate Program",
    err_name: "What's your name?",
    err_sex: "Select gender",
    err_age: "18-100 years",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "Health is the greatest wealth.",
    quote2: "Every step counts.",
    quote3: "Don't stop when you're tired, stop when you're done.",
    quote4: "Discipline is the bridge between goals and accomplishment.",
    quote5: "Your body can stand almost anything. It’s your mind that you have to convince."
  },
  es: {
    welcome: "Hola",
    welcome_female: "Hola",
    dear_male: "Querido",
    dear_female: "Querida",
    morning: "buenos días",
    evening: "buenas noches",
    profile: "Perfil",
    history: "Historial",
    radio: "Radio",
    fullscreen: "Pantalla Completa",
    loading: "Cargando...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Música para entrenar",
    playing: "Reproduciendo...",
    paused: "Pausado",
    click_to_play: "Clic para escuchar",
    live: "EN VIVO",
    want_music: "¿Quieres escuchar música?",
    yes: "Sí",
    no: "No",
    did_you_know: "¿Sabías cómo te ayuda caminar hoy?",
    intensity_title: "Intensidad",
    locked: "Bloqueado",
    start: "Inicio",
    start_desc: "10 min - Calentamiento",
    easy: "Fácil",
    easy_desc: "Ritmo ligero",
    medium: "Medio",
    medium_desc: "Esfuerzo moderado",
    intense: "Intenso",
    intense_desc: "Desafío",
    msg_start: "¡Empecemos a dar pasos!",
    msg_easy: "Tomémoslo con calma hoy, sin estrés.",
    msg_medium: "¡Ni muy fácil hoy, el medio funciona mejor!",
    msg_intense: "¡Día de desafío, seamos intensos y enérgicos!",
    msg_default: "¿Listo para moverte?",
    active_profile: "Perfil Activo",
    age_sex: "Edad y Sexo",
    years: "años",
    body: "Cuerpo",
    bmi_calc: "IMC Calculado",
    optimized_for: "Optimizado para",
    underweight: "Bajo peso",
    normal: "Normal",
    overweight: "Sobrepeso",
    obese: "Obeso",
    sedentary: "Sedentario",
    beginner: "Principiante",
    intermediate: "Intermedio",
    advanced: "Avanzado",
    warmup: "Calentamiento",
    workout: "Entrenamiento",
    cooldown: "Enfriamiento",
    time_remaining: "Tiempo Restante",
    total_time: "Tiempo Total",
    speed: "Velocidad",
    distance: "Distancia",
    steps: "Pasos",
    covered: "recorridos",
    progress: "Progreso",
    pause: "Pausa",
    resume: "Reanudar",
    continue: "Continuar",
    stop_confirm: "¿Quieres detenerte y guardar el progreso?",
    congrats: "¡Felicidades! ¡Entrenamiento completado!",
    structure: "Estructura",
    est_km: "km Estimados",
    target_steps: "Pasos Objetivo",
    min: "min",
    sec: "seg",
    history_title: "Historial de Actividad",
    history_subtitle: "Rastrea tu progreso",
    sessions: "Sesiones",
    no_history: "Sin sesiones guardadas.",
    start_workout: "¡Inicia un entrenamiento!",
    delete_history: "Borrar historial",
    delete_confirm: "¿Seguro que quieres borrar el historial?",
    lets_start: "Empecemos",
    setup_profile: "Configura tu perfil para un plan personalizado.",
    language: "Idioma",
    firstname: "Nombre",
    firstname_placeholder: "ej. Andrés",
    gender: "Género",
    male: "Hombre",
    female: "Mujer",
    age: "Edad",
    height: "Altura (cm)",
    weight: "Peso (kg)",
    activity_level: "Nivel de Actividad",
    level_sedentary: "Sedentario (Poco movimiento)",
    level_beginner: "Principiante (Ocasional)",
    level_intermediate: "Intermedio (Activo regular)",
    level_advanced: "Avanzado (Atleta)",
    generate_program: "Generar Programa",
    err_name: "¿Cómo te llamas?",
    err_sex: "Selecciona género",
    err_age: "18-100 años",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "La salud es la mayor riqueza.",
    quote2: "Cada paso cuenta.",
    quote3: "No te detengas cuando estés cansado, detente cuando hayas terminado.",
    quote4: "La disciplina es el puente entre metas y logros.",
    quote5: "Tu cuerpo puede con todo. Es a tu mente a la que tienes que convencer."
  },
  fr: {
    welcome: "Bonjour",
    welcome_female: "Bonjour",
    dear_male: "Cher",
    dear_female: "Chère",
    morning: "bonjour",
    evening: "bonsoir",
    profile: "Profil",
    history: "Historique",
    radio: "Radio",
    fullscreen: "Plein Écran",
    loading: "Chargement...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Musique d'entraînement",
    playing: "Lecture...",
    paused: "Pause",
    click_to_play: "Cliquez pour écouter",
    live: "EN DIRECT",
    want_music: "Voulez-vous écouter de la musique ?",
    yes: "Oui",
    no: "Non",
    did_you_know: "Saviez-vous comment la marche vous aide aujourd'hui ?",
    intensity_title: "Intensité",
    locked: "Verrouillé",
    start: "Départ",
    start_desc: "10 min - Échauffement",
    easy: "Facile",
    easy_desc: "Rythme léger",
    medium: "Moyen",
    medium_desc: "Effort modéré",
    intense: "Intense",
    intense_desc: "Défi",
    msg_start: "Commençons à marcher !",
    msg_easy: "Doucement aujourd'hui, pas de stress.",
    msg_medium: "Pas trop facile aujourd'hui, moyen c'est mieux !",
    msg_intense: "Jour de défi, soyons intenses et énergiques !",
    msg_default: "Prêt à bouger ?",
    active_profile: "Profil Actif",
    age_sex: "Âge & Sexe",
    years: "ans",
    body: "Corps",
    bmi_calc: "IMC Calculé",
    optimized_for: "Optimisé pour",
    underweight: "Insuffisance pondérale",
    normal: "Normal",
    overweight: "Surpoids",
    obese: "Obèse",
    sedentary: "Sédentaire",
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
    warmup: "Échauffement",
    workout: "Entraînement",
    cooldown: "Récupération",
    time_remaining: "Temps Restant",
    total_time: "Temps Total",
    speed: "Vitesse",
    distance: "Distance",
    steps: "Pas",
    covered: "parcourus",
    progress: "Progrès",
    pause: "Pause",
    resume: "Reprendre",
    continue: "Continuer",
    stop_confirm: "Voulez-vous arrêter et sauvegarder ?",
    congrats: "Félicitations ! Entraînement terminé !",
    structure: "Structure",
    est_km: "km Est.",
    target_steps: "Pas Cibles",
    min: "min",
    sec: "sec",
    history_title: "Historique d'Activité",
    history_subtitle: "Suivez vos progrès",
    sessions: "Séances",
    no_history: "Aucune séance enregistrée.",
    start_workout: "Commencez un entraînement !",
    delete_history: "Effacer l'historique",
    delete_confirm: "Êtes-vous sûr de vouloir tout effacer ?",
    lets_start: "Commençons",
    setup_profile: "Configurez votre profil pour un plan personnalisé.",
    language: "Langue",
    firstname: "Prénom",
    firstname_placeholder: "ex. Pierre",
    gender: "Sexe",
    male: "Homme",
    female: "Femme",
    age: "Âge",
    height: "Taille (cm)",
    weight: "Poids (kg)",
    activity_level: "Niveau d'activité",
    level_sedentary: "Sédentaire (Peu de mouvement)",
    level_beginner: "Débutant (Occasionnel)",
    level_intermediate: "Intermédiaire (Actif régulier)",
    level_advanced: "Avancé (Athlète)",
    generate_program: "Générer Programme",
    err_name: "Quel est votre nom ?",
    err_sex: "Sélectionnez le sexe",
    err_age: "18-100 ans",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "La santé est la plus grande richesse.",
    quote2: "Chaque pas compte.",
    quote3: "Ne t'arrête pas quand tu es fatigué, arrête-toi quand tu as fini.",
    quote4: "La discipline est le pont entre les objectifs et les réalisations.",
    quote5: "Votre corps peut presque tout supporter. C’est votre esprit qu’il faut convaincre."
  },
  de: {
    welcome: "Hallo",
    welcome_female: "Hallo",
    dear_male: "Lieber",
    dear_female: "Liebe",
    morning: "guten Morgen",
    evening: "guten Abend",
    profile: "Profil",
    history: "Verlauf",
    radio: "Radio",
    fullscreen: "Vollbild",
    loading: "Laden...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Trainingsmusik",
    playing: "Wiedergabe...",
    paused: "Pausiert",
    click_to_play: "Klicken zum Abspielen",
    live: "LIVE",
    want_music: "Möchtest du Musik hören?",
    yes: "Ja",
    no: "Nein",
    did_you_know: "Wusstest du, wie Gehen dir heute hilft?",
    intensity_title: "Intensität",
    locked: "Gesperrt",
    start: "Start",
    start_desc: "10 Min - Aufwärmen",
    easy: "Leicht",
    easy_desc: "Lockeres Tempo",
    medium: "Mittel",
    medium_desc: "Mäßige Anstrengung",
    intense: "Intensiv",
    intense_desc: "Herausforderung",
    msg_start: "Lass uns anfangen zu laufen!",
    msg_easy: "Heute ganz entspannt, kein Stress.",
    msg_medium: "Nicht zu leicht heute, mittel ist am besten!",
    msg_intense: "Herausforderungstag, lass uns intensiv und energiegeladen sein!",
    msg_default: "Bereit für Bewegung?",
    active_profile: "Aktives Profil",
    age_sex: "Alter & Geschlecht",
    years: "Jahre",
    body: "Körper",
    bmi_calc: "BMI Berechnet",
    optimized_for: "Optimiert für",
    underweight: "Untergewicht",
    normal: "Normal",
    overweight: "Übergewicht",
    obese: "Adipositas",
    sedentary: "Sitzend",
    beginner: "Anfänger",
    intermediate: "Fortgeschritten",
    advanced: "Profi",
    warmup: "Aufwärmen",
    workout: "Training",
    cooldown: "Abkühlen",
    time_remaining: "Verbleibende Zeit",
    total_time: "Gesamtzeit",
    speed: "Geschw.",
    distance: "Distanz",
    steps: "Schritte",
    covered: "zurückgelegt",
    progress: "Fortschritt",
    pause: "Pause",
    resume: "Fortsetzen",
    continue: "Weiter",
    stop_confirm: "Möchtest du anhalten und speichern?",
    congrats: "Glückwunsch! Training beendet!",
    structure: "Struktur",
    est_km: "Geschätzte km",
    target_steps: "Zielschritte",
    min: "Min",
    sec: "Sek",
    history_title: "Aktivitätsverlauf",
    history_subtitle: "Verfolge deinen Fortschritt",
    sessions: "Sitzungen",
    no_history: "Noch keine Sitzungen gespeichert.",
    start_workout: "Starte ein Training!",
    delete_history: "Verlauf löschen",
    delete_confirm: "Bist du sicher, dass du den Verlauf löschen möchtest?",
    lets_start: "Lass uns beginnen",
    setup_profile: "Richte dein Profil für einen persönlichen Plan ein.",
    language: "Sprache",
    firstname: "Vorname",
    firstname_placeholder: "z.B. Hans",
    gender: "Geschlecht",
    male: "Mann",
    female: "Frau",
    age: "Alter",
    height: "Größe (cm)",
    weight: "Gewicht (kg)",
    activity_level: "Aktivitätslevel",
    level_sedentary: "Sitzend (Wenig Bewegung)",
    level_beginner: "Anfänger (Gelegentlich)",
    level_intermediate: "Fortgeschritten (Regelmäßig aktiv)",
    level_advanced: "Profi (Sportler)",
    generate_program: "Programm erstellen",
    err_name: "Wie heißt du?",
    err_sex: "Geschlecht wählen",
    err_age: "18-100 Jahre",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "Gesundheit ist der größte Reichtum.",
    quote2: "Jeder Schritt zählt.",
    quote3: "Hör nicht auf, wenn du müde bist, hör auf, wenn du fertig bist.",
    quote4: "Disziplin ist die Brücke zwischen Zielen und Erfolgen.",
    quote5: "Dein Körper kann fast alles aushalten. Es ist dein Geist, den du überzeugen musst."
  },
  it: {
    welcome: "Ciao",
    welcome_female: "Ciao",
    dear_male: "Caro",
    dear_female: "Cara",
    morning: "buongiorno",
    evening: "buonasera",
    profile: "Profilo",
    history: "Cronologia",
    radio: "Radio",
    fullscreen: "Schermo Intero",
    loading: "Caricamento...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Musica per allenamento",
    playing: "In riproduzione...",
    paused: "In pausa",
    click_to_play: "Clicca per ascoltare",
    live: "DAL VIVO",
    want_music: "Vuoi ascoltare musica?",
    yes: "Sì",
    no: "No",
    did_you_know: "Sapevi come ti aiuta camminare oggi?",
    intensity_title: "Intensità",
    locked: "Bloccato",
    start: "Start",
    start_desc: "10 min - Riscaldamento",
    easy: "Facile",
    easy_desc: "Ritmo leggero",
    medium: "Medio",
    medium_desc: "Sforzo moderato",
    intense: "Intenso",
    intense_desc: "Sfida",
    msg_start: "Iniziamo a camminare!",
    msg_easy: "Prendiamola con calma oggi, niente stress.",
    msg_medium: "Non troppo facile oggi, medio è meglio!",
    msg_intense: "Giorno di sfida, siamo intensi ed energici!",
    msg_default: "Pronto a muoverti?",
    active_profile: "Profilo Attivo",
    age_sex: "Età e Sesso",
    years: "anni",
    body: "Corpo",
    bmi_calc: "IMC Calcolato",
    optimized_for: "Ottimizzato per",
    underweight: "Sottopeso",
    normal: "Normale",
    overweight: "Sovrappeso",
    obese: "Obeso",
    sedentary: "Sedentario",
    beginner: "Principiante",
    intermediate: "Intermedio",
    advanced: "Avanzato",
    warmup: "Riscaldamento",
    workout: "Allenamento",
    cooldown: "Defaticamento",
    time_remaining: "Tempo Rimanente",
    total_time: "Tempo Totale",
    speed: "Velocità",
    distance: "Distanza",
    steps: "Passi",
    covered: "percorsi",
    progress: "Progresso",
    pause: "Pausa",
    resume: "Riprendi",
    continue: "Continua",
    stop_confirm: "Vuoi fermarti e salvare i progressi?",
    congrats: "Congratulazioni! Allenamento completato!",
    structure: "Struttura",
    est_km: "km Stimati",
    target_steps: "Passi Obiettivo",
    min: "min",
    sec: "sec",
    history_title: "Cronologia Attività",
    history_subtitle: "Traccia i tuoi progressi",
    sessions: "Sessioni",
    no_history: "Nessuna sessione salvata.",
    start_workout: "Inizia un allenamento!",
    delete_history: "Cancella cronologia",
    delete_confirm: "Sei sicuro di voler cancellare tutto?",
    lets_start: "Iniziamo",
    setup_profile: "Imposta il tuo profilo per un piano personalizzato.",
    language: "Lingua",
    firstname: "Nome",
    firstname_placeholder: "es. Marco",
    gender: "Sesso",
    male: "Uomo",
    female: "Donna",
    age: "Età",
    height: "Altezza (cm)",
    weight: "Peso (kg)",
    activity_level: "Livello di Attività",
    level_sedentary: "Sedentario (Poco movimento)",
    level_beginner: "Principiante (Occasionale)",
    level_intermediate: "Intermedio (Attivo regolare)",
    level_advanced: "Avanzato (Atleta)",
    generate_program: "Genera Programma",
    err_name: "Come ti chiami?",
    err_sex: "Seleziona sesso",
    err_age: "18-100 anni",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "La salute è la più grande ricchezza.",
    quote2: "Ogni passo conta.",
    quote3: "Non fermarti quando sei stanco, fermati quando hai finito.",
    quote4: "La disciplina è il ponte tra obiettivi e risultati.",
    quote5: "Il tuo corpo può sopportare quasi tutto. È la tua mente che devi convincere."
  },
  pt: {
    welcome: "Olá",
    welcome_female: "Olá",
    dear_male: "Querido",
    dear_female: "Querida",
    morning: "bom dia",
    evening: "boa noite",
    profile: "Perfil",
    history: "Histórico",
    radio: "Rádio",
    fullscreen: "Tela Cheia",
    loading: "Carregando...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Música de treino",
    playing: "Reproduzindo...",
    paused: "Pausado",
    click_to_play: "Clique para ouvir",
    live: "AO VIVO",
    want_music: "Você quer ouvir música?",
    yes: "Sim",
    no: "Não",
    did_you_know: "Você sabia como caminhar te ajuda hoje?",
    intensity_title: "Intensidade",
    locked: "Bloqueado",
    start: "Início",
    start_desc: "10 min - Aquecimento",
    easy: "Fácil",
    easy_desc: "Ritmo leve",
    medium: "Médio",
    medium_desc: "Esforço moderado",
    intense: "Intenso",
    intense_desc: "Desafio",
    msg_start: "Vamos começar a caminhar!",
    msg_easy: "Vamos com calma hoje, sem estresse.",
    msg_medium: "Nem muito fácil hoje, médio funciona melhor!",
    msg_intense: "Dia de desafio, vamos ser intensos e enérgicos!",
    msg_default: "Pronto para se mover?",
    active_profile: "Perfil Ativo",
    age_sex: "Idade e Sexo",
    years: "anos",
    body: "Corpo",
    bmi_calc: "IMC Calculado",
    optimized_for: "Otimizado para",
    underweight: "Abaixo do peso",
    normal: "Normal",
    overweight: "Sobrepeso",
    obese: "Obeso",
    sedentary: "Sedentário",
    beginner: "Iniciante",
    intermediate: "Intermediário",
    advanced: "Avançado",
    warmup: "Aquecimento",
    workout: "Treino",
    cooldown: "Resfriamento",
    time_remaining: "Tempo Restante",
    total_time: "Tempo Total",
    speed: "Velocidade",
    distance: "Distância",
    steps: "Passos",
    covered: "percorridos",
    progress: "Progresso",
    pause: "Pausa",
    resume: "Retomar",
    continue: "Continuar",
    stop_confirm: "Deseja parar e salvar o progresso?",
    congrats: "Parabéns! Treino concluído!",
    structure: "Estrutura",
    est_km: "km Estimados",
    target_steps: "Passos Alvo",
    min: "min",
    sec: "seg",
    history_title: "Histórico de Atividade",
    history_subtitle: "Acompanhe seu progresso",
    sessions: "Sessões",
    no_history: "Nenhuma sessão salva.",
    start_workout: "Comece um treino!",
    delete_history: "Limpar histórico",
    delete_confirm: "Tem certeza que deseja limpar tudo?",
    lets_start: "Vamos começar",
    setup_profile: "Configure seu perfil para um plano personalizado.",
    language: "Idioma",
    firstname: "Nome",
    firstname_placeholder: "ex. João",
    gender: "Gênero",
    male: "Homem",
    female: "Mulher",
    age: "Idade",
    height: "Altura (cm)",
    weight: "Peso (kg)",
    activity_level: "Nível de Atividade",
    level_sedentary: "Sedentário (Pouco movimento)",
    level_beginner: "Iniciante (Ocasional)",
    level_intermediate: "Intermediário (Ativo regular)",
    level_advanced: "Avançado (Avançado)",
    generate_program: "Gerar Programa",
    err_name: "Qual é o seu nome?",
    err_sex: "Selecione o gênero",
    err_age: "18-100 anos",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "A saúde é a maior riqueza.",
    quote2: "Cada passo conta.",
    quote3: "Não pare quando estiver cansado, pare quando terminar.",
    quote4: "A disciplina é a ponte entre metas e conquistas.",
    quote5: "Seu corpo aguenta quase tudo. É a sua mente que você precisa convencer."
  },
  ru: {
    welcome: "Привет",
    welcome_female: "Привет",
    dear_male: "Дорогой",
    dear_female: "Дорогая",
    morning: "доброе утро",
    evening: "добрый вечер",
    profile: "Профиль",
    history: "История",
    radio: "Радио",
    fullscreen: "На весь экран",
    loading: "Загрузка...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "Музыка для тренировок",
    playing: "Играет...",
    paused: "На паузе",
    click_to_play: "Нажмите, чтобы слушать",
    live: "LIVE",
    want_music: "Хотите послушать музыку?",
    yes: "Да",
    no: "Нет",
    did_you_know: "Знаете ли вы, как ходьба помогает вам сегодня?",
    intensity_title: "Интенсивность",
    locked: "Закрыто",
    start: "Старт",
    start_desc: "10 мин - Разминка",
    easy: "Легко",
    easy_desc: "Легкий темп",
    medium: "Средне",
    medium_desc: "Умеренное усилие",
    intense: "Интенсивно",
    intense_desc: "Вызов",
    msg_start: "Давайте начнем шагать!",
    msg_easy: "Сегодня полегче, без стресса.",
    msg_medium: "Не слишком легко, средний темп лучше всего!",
    msg_intense: "День вызова, давайте будем энергичными!",
    msg_default: "Готовы к движению?",
    active_profile: "Активный профиль",
    age_sex: "Возраст и Пол",
    years: "лет",
    body: "Тело",
    bmi_calc: "ИМТ Рассчитан",
    optimized_for: "Оптимизировано для",
    underweight: "Недостаточный вес",
    normal: "Норма",
    overweight: "Избыточный вес",
    obese: "Ожирение",
    sedentary: "Сидячий",
    beginner: "Новичок",
    intermediate: "Средний",
    advanced: "Продвинутый",
    warmup: "Разминка",
    workout: "Тренировка",
    cooldown: "Заминка",
    time_remaining: "Осталось времени",
    total_time: "Общее время",
    speed: "Скорость",
    distance: "Дистанция",
    steps: "Шаги",
    covered: "пройдено",
    progress: "Прогресс",
    pause: "Пауза",
    resume: "Продолжить",
    continue: "Продолжить",
    stop_confirm: "Хотите остановиться и сохранить прогресс?",
    congrats: "Поздравляем! Тренировка завершена!",
    structure: "Структура",
    est_km: "км (оценка)",
    target_steps: "Цель шагов",
    min: "мин",
    sec: "сек",
    history_title: "История активности",
    history_subtitle: "Отслеживайте прогресс",
    sessions: "Сессии",
    no_history: "Нет сохраненных сессий.",
    start_workout: "Начните тренировку!",
    delete_history: "Очистить историю",
    delete_confirm: "Вы уверены, что хотите удалить все?",
    lets_start: "Начнем",
    setup_profile: "Настройте профиль для персонального плана.",
    language: "Язык",
    firstname: "Имя",
    firstname_placeholder: "напр. Иван",
    gender: "Пол",
    male: "Мужчина",
    female: "Женщина",
    age: "Возраст",
    height: "Рост (см)",
    weight: "Вес (кг)",
    activity_level: "Уровень активности",
    level_sedentary: "Сидячий (Мало движения)",
    level_beginner: "Новичок (Редко)",
    level_intermediate: "Средний (Регулярно)",
    level_advanced: "Продвинутый (Атлет)",
    generate_program: "Создать программу",
    err_name: "Как вас зовут?",
    err_sex: "Выберите пол",
    err_age: "18-100 лет",
    err_height: "140-220 см",
    err_weight: "40-200 kg",
    quote1: "Здоровье — это главное богатство.",
    quote2: "Каждый шаг важен.",
    quote3: "Не останавливайся, когда устал, останавливайся, когда закончил.",
    quote4: "Дисциплина — это мост между целями и достижениями.",
    quote5: "Твое тело может выдержать почти все. Убедить нужно свой разум."
  },
  zh: {
    welcome: "你好",
    welcome_female: "你好",
    dear_male: "亲爱的",
    dear_female: "亲爱的",
    morning: "早上好",
    evening: "晚上好",
    profile: "个人资料",
    history: "历史记录",
    radio: "收音机",
    fullscreen: "全屏",
    loading: "加载中...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "训练音乐",
    playing: "播放中...",
    paused: "暂停",
    click_to_play: "点击播放",
    live: "直播",
    want_music: "你想听音乐吗？",
    yes: "是",
    no: "不",
    did_you_know: "你知道今天走路对你有什么帮助吗？",
    intensity_title: "强度",
    locked: "已锁定",
    start: "开始",
    start_desc: "10分钟 - 热身",
    easy: "轻松",
    easy_desc: "轻松的步伐",
    medium: "中等",
    medium_desc: "适度努力",
    intense: "高强度",
    intense_desc: "挑战",
    msg_start: "让我们开始迈步！",
    msg_easy: "今天轻松一点，没有压力。",
    msg_medium: "今天不要太轻松，中等强度最好！",
    msg_intense: "挑战日，让我们充满活力！",
    msg_default: "准备好运动了吗？",
    active_profile: "当前档案",
    age_sex: "年龄 & 性别",
    years: "岁",
    body: "身体数据",
    bmi_calc: "BMI 计算值",
    optimized_for: "专为优化",
    underweight: "体重不足",
    normal: "正常",
    overweight: "超重",
    obese: "肥胖",
    sedentary: "久坐",
    beginner: "初学者",
    intermediate: "中级",
    advanced: "高级",
    warmup: "热身",
    workout: "训练",
    cooldown: "放松",
    time_remaining: "剩余时间",
    total_time: "总时间",
    speed: "速度",
    distance: "距离",
    steps: "步数",
    covered: "已覆盖",
    progress: "进度",
    pause: "暂停",
    resume: "继续",
    continue: "继续",
    stop_confirm: "您想停止并保存当前进度吗？",
    congrats: "恭喜！训练完成！",
    structure: "结构",
    est_km: "预估公里",
    target_steps: "目标步数",
    min: "分",
    sec: "秒",
    history_title: "活动历史",
    history_subtitle: "追踪您的进度",
    sessions: "训练场次",
    no_history: "暂无保存的记录。",
    start_workout: "开始训练！",
    delete_history: "清除历史",
    delete_confirm: "您确定要清除所有历史记录吗？",
    lets_start: "开始吧",
    setup_profile: "设置您的个人资料以获取个性化计划。",
    language: "语言",
    firstname: "名字",
    firstname_placeholder: "例如：李明",
    gender: "性别",
    male: "男",
    female: "女",
    age: "年龄",
    height: "身高 (cm)",
    weight: "体重 (kg)",
    activity_level: "活动水平",
    level_sedentary: "久坐 (很少运动)",
    level_beginner: "初学者 (偶尔)",
    level_intermediate: "中级 (经常活动)",
    level_advanced: "高级 (运动员)",
    generate_program: "生成计划",
    err_name: "您叫什么名字？",
    err_sex: "选择性别",
    err_age: "18-100 岁",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "健康是最大的财富。",
    quote2: "每一步都很重要。",
    quote3: "不要在累的时候停下来，要在完成的时候停下来。",
    quote4: "自律是目标和成就之间的桥梁。",
    quote5: "你的身体几乎可以承受任何事情。你需要说服的是你的头脑。"
  },
  ja: {
    welcome: "こんにちは",
    welcome_female: "こんにちは",
    dear_male: "親愛なる",
    dear_female: "親愛なる",
    morning: "おはようございます",
    evening: "こんばんは",
    profile: "プロフィール",
    history: "履歴",
    radio: "ラジオ",
    fullscreen: "全画面",
    loading: "読み込み中...",
    radio_title: "RadioWish Transylvania",
    radio_subtitle: "トレーニング音楽",
    playing: "再生中...",
    paused: "一時停止",
    click_to_play: "クリックして再生",
    live: "ライブ",
    want_music: "音楽を聴きますか？",
    yes: "はい",
    no: "いいえ",
    did_you_know: "今日、ウォーキングがどのように役立つか知っていましたか？",
    intensity_title: "強度",
    locked: "ロック中",
    start: "開始",
    start_desc: "10分 - ウォームアップ",
    easy: "簡単",
    easy_desc: "軽いペース",
    medium: "普通",
    medium_desc: "適度な努力",
    intense: "激しい",
    intense_desc: "チャレンジ",
    msg_start: "歩き始めましょう！",
    msg_easy: "今日は気楽に、ストレスなしで。",
    msg_medium: "今日は簡単すぎず、普通が一番！",
    msg_intense: "チャレンジの日、エネルギッシュに行こう！",
    msg_default: "運動の準備はできましたか？",
    active_profile: "アクティブプロファイル",
    age_sex: "年齢 & 性別",
    years: "歳",
    body: "身体",
    bmi_calc: "BMI 計算値",
    optimized_for: "最適化対象",
    underweight: "低体重",
    normal: "普通",
    overweight: "過体重",
    obese: "肥満",
    sedentary: "座り仕事",
    beginner: "初心者",
    intermediate: "中級者",
    advanced: "上級者",
    warmup: "ウォームアップ",
    workout: "ワークアウト",
    cooldown: "クールダウン",
    time_remaining: "残り時間",
    total_time: "合計時間",
    speed: "速度",
    distance: "距離",
    steps: "歩数",
    covered: "完了",
    progress: "進捗",
    pause: "一時停止",
    resume: "再開",
    continue: "続ける",
    stop_confirm: "停止して進捗を保存しますか？",
    congrats: "おめでとうございます！トレーニング完了！",
    structure: "構成",
    est_km: "推定 km",
    target_steps: "目標歩数",
    min: "分",
    sec: "秒",
    history_title: "活動履歴",
    history_subtitle: "進捗を確認",
    sessions: "セッション",
    no_history: "保存されたセッションはありません。",
    start_workout: "トレーニングを開始！",
    delete_history: "履歴を削除",
    delete_confirm: "本当にすべての履歴を削除しますか？",
    lets_start: "始めましょう",
    setup_profile: "パーソナルプランのためにプロフィールを設定してください。",
    language: "言語",
    firstname: "名前",
    firstname_placeholder: "例：太郎",
    gender: "性別",
    male: "男性",
    female: "女性",
    age: "年齢",
    height: "身長 (cm)",
    weight: "体重 (kg)",
    activity_level: "活動レベル",
    level_sedentary: "座り仕事 (運動不足)",
    level_beginner: "初心者 (時々)",
    level_intermediate: "中級者 (定期的)",
    level_advanced: "上級者 (アスリート)",
    generate_program: "プログラム作成",
    err_name: "お名前は何ですか？",
    err_sex: "性別を選択",
    err_age: "18-100 歳",
    err_height: "140-220 cm",
    err_weight: "40-200 kg",
    quote1: "健康は最大の富である。",
    quote2: "一歩一歩が大切。",
    quote3: "疲れたときに止まるな、終わったときに止まれ。",
    quote4: "規律は目標と達成の間の架け橋である。",
    quote5: "あなたの体はほとんど何でも耐えられる。説得すべきはあなたの心だ。"
  }
};